module.exports = __webpack_public_path__ + "img/preview_vess.e85895f2.gif";